<app-modal-header title="Resolve Unlinked {{ typeText }}s" [close]="closeModal"></app-modal-header>
@if (noLinks.length > 0) {
  <div class="no-links">
    <div>
      <h6><b>The following {{ typeText }}s have no links ((<< OF STORE ? >>)), and their are now entries using the same IDs either.<br>
        They will not be copied<b></b><br><br>
        If you wish to create links for these {{ typeText }}s please do so in the Store Linkages tool in settings.</b>
      </h6>
      <ul>
        @for (dep of noLinks; track $index) {
          <li>
            {{ dep }}
          </li>
        }
      </ul>
    </div>
  </div>
}
<div class="modal-body">
  @for (suggestion of suggestLinks; track trackBySuggestion(i, suggestion); let i = $index) {
    <div class="clearfix">
      <span>{{ typeText }} <b><i>({{ suggestion.storeA.depId }}) - {{ suggestion.storeA.name }}</i></b> does not have any links for this store.<br>
      <b><i>({{ suggestion.storeB.depId }}) - {{ suggestion.storeB.name }}</i></b> has the same ID.<br>
      Do you want to use this {{ typeText }}
    </span>
      <div class="button-div">
        <app-shared-button (buttonClicked)="addDepartment(i)" [fill]="true">Yes</app-shared-button>
        <app-shared-button (buttonClicked)="removeDepartmentFromView(i)" [fill]="false">No</app-shared-button>
      </div>
    </div>
  }
</div>

